import {
  routeHasHiddenSteps,
  transformEditPathInputDataToProcessRouteStepInput,
} from "@/modules/admin-panel/bpm-routes/shared/ui/path-input/path-input-utils";
import { DYNAMIC_PROCESS_FORM } from "../dynamic-process-form-provider/forms-enum";
import { DynamicProcessPathForm } from "../dynamic-process-path-form";
import { FieldsType, Model } from "../../model/types";
import { HiddenFieldsAlert } from "@/shared/value";

export function PathForm({ model }: { model: Model }) {
  const hasHiddenSteps = routeHasHiddenSteps(model?.route ?? []);

  return (
    <>
      {hasHiddenSteps && <HiddenFieldsAlert />}

      <DynamicProcessPathForm
        disabled={hasHiddenSteps}
        name={DYNAMIC_PROCESS_FORM.PATH}
        initialValues={
          {
            route: model?.route.map(
              transformEditPathInputDataToProcessRouteStepInput,
            ),
          } as Partial<FieldsType>
        }
      />
    </>
  );
}
